const LAST_PATH_KEY = 'last_visited_path';

export const saveLastPath = (path: string): void => {
  // Evitamos guardar rutas de login o logout
  if (!path.includes('/auth')) {
    localStorage.setItem(LAST_PATH_KEY, path);
  }
};

export const getLastPath = (): string => {
  return localStorage.getItem(LAST_PATH_KEY) || '/main/landing';
};